const SET_CREDENTIALS = 'SET_CREDENTIALS';

const setCredentials = ({ identityId, mpUserId }) => ({
  type: SET_CREDENTIALS,
  payload: {
    identityId,
    mpUserId
  }
});

export { SET_CREDENTIALS, setCredentials };
